import React from "react";
import { Fade } from "react-slideshow-image";
import sliderImage from '../js/slideImage'
import styles from "../styles/slider.module.css"

const Slideshow = () => {
    const images = sliderImage;
    console.log(images);
    const zoomOutProperties = {
        duration: 3000,
        transitionDuration: 600,
        infinite: true,
        indicators: false,
        scale: 0.4,
        arrows: false
    };
    return (
        <div>
            <Fade {...zoomOutProperties}>
                {images.map((each, index) => (
                    <div className={styles.content_slider}>
                        <div className={styles.slider_slider}>
                            <p className={styles.name_slider}>{each.name}</p>
                        </div>
                        <img key={index} className={styles.img_slider} src={each.image} />
                        <div className={styles.skills_slider}>
                            <p><i class="bi bi-lightning-charge"></i>{each.first}</p>
                            <p><i class="bi bi-lightning-charge"></i>{each.second}</p>
                            <p><i class="bi bi-lightning-charge"></i>{each.third}</p>
                        </div>
                    </div>
                ))}
            </Fade>
        </div>
    );
};

export default Slideshow;
